<ng-select
  [ngModel]="selectedOption()"
  (ngModelChange)="onChange($event)"
  [disabled]="disabled()"
  [placeholder]="placeholder()"
  [items]="items()"
  (blur)="onBlur()"
  [labelForId]="searchInputId()"
  [clearable]="false"
  (close)="onClose()"
  appendTo="body"
  outsideClickEvent="mousedown"
  [keyDownFn]="onKeyDown"
  [attr.aria-label]="selectedOption()?.label ?? placeholder()"
>
  <ng-template ng-label-tmp let-item="item">
    <div class="tw-flex tw-items-center tw-gap-2 tw-min-w-0" [title]="item.label">
      <ng-container
        [ngTemplateOutlet]="leadingVisual"
        [ngTemplateOutletContext]="{ item: item }"
      ></ng-container>
      <span class="tw-truncate">{{ item.label }}</span>
    </div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <div class="tw-flex tw-justify-between tw-items-center" [title]="item.label">
      <div class="tw-flex tw-items-center tw-gap-2 tw-flex-1 tw-min-w-0">
        <div class="tw-flex-initial tw-self-center">
          <ng-container
            [ngTemplateOutlet]="leadingVisual"
            [ngTemplateOutletContext]="{ item: item }"
          ></ng-container>
        </div>
        <div class="tw-flex tw-flex-col tw-min-w-0">
          <div
            bitTypography="body2"
            class="tw-leading-5 tw-flex-1 tw-text-ellipsis tw-overflow-hidden"
          >
            {{ item.label }}
          </div>
          @if (item.description) {
            <div bitTypography="helper" class="tw-text-fg-body tw-font-normal tw-truncate">
              {{ item.description }}
            </div>
          }
        </div>
      </div>
      @if (item.metaData) {
        <div bitTypography="helper">
          {{ item.metaData }}
        </div>
      }
    </div>
  </ng-template>
</ng-select>

<!-- Shared by the selected value and the dropdown rows: an icon tile when provided, otherwise a plain icon. -->
<ng-template #leadingVisual let-item="item">
  @if (item.iconTile) {
    <!-- tw-flex on the host: its inner box is inline-flex, so an inline host would add a line box's
         worth of descender space below the tile and push it above the row's center. -->
    <bit-icon-tile
      class="!tw-flex"
      [icon]="item.iconTile.icon"
      [variant]="tileVariant(item)"
      [color]="tileColor(item)"
      [emphasis]="item.iconTile.emphasis ?? 'subtle'"
      size="xs"
    />
  } @else if (item.icon != null) {
    <bit-icon [name]="item.icon" fixedWidth />
  }
</ng-template>
